import { z } from 'zod';

// Helper: Convert empty string to undefined (for optional ObjectId fields)
const optionalObjectId = z.string().optional().transform(val => (val === '' ? undefined : val));
const optionalString = z.string().optional().transform(val => (val === '' ? undefined : val));

export const ProcessSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    code: optionalString,
    name: z.string().min(1),
    description: optionalString,
    unit: optionalObjectId,
    rto: optionalString,
    rpo: optionalString,
    mtpd: optionalString,
    criticality: z.enum(['low', 'medium', 'high', 'critical']).default('medium'),
    processOwner: optionalObjectId,
    assets: z.array(z.string()).optional().default([]),
    relatedObligations: z.array(z.string()).optional().default([]),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});

export const CreateProcessSchema = ProcessSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateProcessSchema = ProcessSchema.partial();
export const ProcessFormSchema = ProcessSchema;
